import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
    :root {
        --standard-color: #f1b924;
        --secondary-color: #171717;
        --text-color: #171717;
        --muted-text-color: #484848;
        --surface-color: #faf7ee;
        --raised-surface-color: #fdf8e8;
        --field-surface-color: #fffaf0;
        --border-color: #e8dcc4;
        --accent-color: #F1B924;
        --accent-hover-color: #bd8d0f;
        --font-family: 'Lato', sans-serif;
    }

    * {
        font-family: var(--font-family);
        font-weight: 300;
        font-style: normal;
        font-optical-sizing: auto;
        font-variation-settings: 'wdth' 100;
    }

    .gktKcs {
        background-color: transparent;
    }

    h1 {
        font-family: var(--font-family);
        font-weight: 600;
        font-style: normal;
    }

    h2 {
        font-family: var(--font-family);
        font-weight: 550;
        font-style: normal;
    }

    h3 {
        font-family: var(--font-family);
        font-weight: 500;
        font-style: normal;
    }

    body {
        background-color: var(--standard-color);
        color: var(--text-color);
    }

    .modal-content.background {
        background: var(--surface-color);
        border: 1px solid var(--border-color);
        border-radius: 12px;
        color: var(--text-color);
        overflow: hidden;
    }

    .modal-content.background .modal-header {
        //background: var(--raised-surface-color);
        background: white;
        //border-bottom: 1px solid var(--border-color);
        border: 0;
        padding: 1rem 1.25rem;
    }

    .modal-content.background .modal-title {
        color: var(--text-color);
        font-size: 1.25rem;
        font-weight: 700;
        font-weight: 700;
    }

    .modal-content.background .modal-body {
        //background: var(--surface-color);
        background: white;
        line-height: 1.6;
        padding: 1.25rem;
    }

    .modal-content.background .modal-body p {
        color: var(--muted-text-color);
    }

    .modal-content.background .modal-footer {
        //background: var(--raised-surface-color);
        background: white;
        //border-top: 1px solid var(--border-color);
        border: 0;
        padding: 0.75rem 1.25rem;
    }

    .modal-content.background .modal-button,
    .modal-content.background .btn-primary {
        background: var(--accent-color);
        border-color: var(--accent-color);
        border-radius: 999px;
        color: var(--text-color);
        font-weight: 700;
        min-height: 40px;
        min-width: 100px;
    }

    .modal-content.background .modal-button:hover,
    .modal-content.background .modal-button:focus,
    .modal-content.background .btn-primary:hover,
    .modal-content.background .btn-primary:focus {
        background: var(--accent-hover-color);
        border-color: var(--accent-hover-color);
        color: var(--text-color);
    }

    .app-icon-image-box {
        display: flex;
        gap: 1rem;
        justify-content: center;
        margin: 1.25rem 0;
    }

    .app-icon-image-box img {
        background: var(--field-surface-color);
        border: 1px solid var(--border-color);
        border-radius: 8px;
        padding: 0.35rem;
    }

    .alert-warning,
    .alert-info {
        background: #fff3c7;
        border-color: #dfbd58;
        color: var(--text-color);
    }

    @media (max-width: 575px) {
        .modal-content.background .modal-header,
        .modal-content.background .modal-body,
        .modal-content.background .modal-footer {
            padding-left: 0.85rem;
            padding-right: 0.85rem;
        }

        .modal-content.background .modal-button,
        .modal-content.background .btn-primary {
            min-height: 44px;
        }
    }

    .help-icon:hover {
        cursor: help;
    }
`;

export default GlobalStyles;
